import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type {
	PreviewLinkByPreviewIdPetitionGammaQuery,
	PreviewLinkByPreviewIdPetitionGammaQueryVariables,
} from './getPreviewLink.graphql';
import { PreviewLinkByPreviewIdPetitionGamma } from './getPreviewLink.graphql';

export type FilterKey = PreviewLinkByPreviewIdPetitionGammaQueryVariables['filterKey'];
export type PreviewLinkResult = PreviewLinkByPreviewIdPetitionGammaQuery['getPreviewLinks'];

export async function getPreviewLinkById(
	slug: string,
	{ gql: { fetch } }: UtilityContext,
	filterKey: FilterKey,
	filterValue: string | null,
): Promise<PreviewLinkResult> {
	const { data } = await fetch<
		PreviewLinkByPreviewIdPetitionGammaQuery,
		PreviewLinkByPreviewIdPetitionGammaQueryVariables
	>({
		query: PreviewLinkByPreviewIdPetitionGamma,
		variables: { slug, filterKey, filterValue },
		rejectOnError: true,
	});
	return data.getPreviewLinks;
}
